import { Modal, Button } from "react-bootstrap";
import React, { Component, useEffect, useState } from "react";
import dict from "../services/dictionaryService";

const Dictionary =({ dictionaryShowHide, handledictionaryShowHide, selectedText })=> {

  const[definition, setDefinition] = useState([])
  const[term, setTerm] = useState("")

  const handleOnChange = ({ currentTarget: input }) => {
    setTerm(input.value)
  };

  const handleSearchWord = async () => {
    getDefinition(term);
  };

  const getDefinition = async (term) => {
    const { data } = await dict.define(term);
    console.log(data.list);
    setDefinition(data.list)
  };

  const handleReset = () => {
    setDefinition([])
    setTerm("")
  };

  useEffect(() => {
    if (selectedText !== undefined && selectedText !== "") {
      getDefinition(selectedText);
    }
  }, [selectedText]);

  const handleClose = () => {
    handledictionaryShowHide();
  };

  const handleCloseDictionary = () => {
    document.body.classList.remove("INDdictionary");
    handledictionaryShowHide();
  };
    return (
      <Modal
        show={dictionaryShowHide}
        size="lg"
        dialogClassName="modalLeftRight modalRight"
        onHide={handleClose}
      >
        <Modal.Header closeButton onClick={handledictionaryShowHide}>
          <Modal.Title>Dictionary</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary">
          <div className="row">
            <div className="col-md-12 form-group">
              <input
                type="text"
                className="form-control"
                name="term"
                id="term"
                value={selectedText}
                onChange={handleOnChange}
              />
            </div>
            <div className="col-md-12 form-group text-center">
              <button
                className="btn btn-outline-default btn-sm"
                onClick={handleSearchWord}
              >
                Search
              </button>
              <button
                className="btn btn-outline-default btn-sm"
                onClick={handleReset}
              >
                Reset
              </button>
              <button className="btn btn-outline-default btn-sm" onClick={handleCloseDictionary}>
                 Close
              </button>
            </div>
            <div className="col-md-12">
              <ul className="list-group">
                {definition.map((item) => (
                  <React.Fragment>
                    <li className="list-group-item">
                      <span className="h4">Example : </span>
                      {item.example}
                    </li>
                  </React.Fragment>
                ))}
              </ul>
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer className="justify-content-center">
          <Button variant="danger" onClick={handledictionaryShowHide}>
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    );
  // }
}

export default Dictionary;
